import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
export class CalendarHeaderComponent implements OnInit {

   view: string;

   viewDate: Date;

   locale = 'fr';

   events: any[];

   viewChange: EventEmitter<string> = new EventEmitter();

   viewDateChange: EventEmitter<Date> = new EventEmitter();

  views: any[] = [
    { text: 'Month', value: 'month' },
    { text: 'Week', value: 'week' },
    { text: 'Day', value: 'day' },
    { text: 'Schedule', value: 'schedule' },
    { text: 'Year', value: 'year' },
  ];
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }


static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'calendar-header',
  template: `
    <div class="col-md-3 flex-mobile-center">
          <div class="btn-group">
            <div
              class="btn-circle"
              appCalendarPreviousView
              [view]="view"
              [(viewDate)]="viewDate"
              (viewDateChange)="viewDateChange.next(viewDate)">
              <i class="fa fa-chevron-left"></i>
            </div>
            <div
              class="btn btn-sm btn-today"
              appCalendarToday
              [(viewDate)]="viewDate"
              (viewDateChange)="viewDateChange.next(viewDate)">
              Today
            </div>
            <div
              class="btn-circle"
              appCalendarNextView
              [view]="view"
              [(viewDate)]="viewDate"
              (viewDateChange)="viewDateChange.next(viewDate)">
              <i class="fa fa-chevron-right"></i>
            </div>
          </div>
    </div>
    <div *ngIf="view === 'week' || view === 'month' || view === 'schedule' || view === 'year'" class="col-md-4 todate">
          {{ viewDate | date: 'MMMM yyyy' }}
    </div>
    <div *ngIf="view === 'day'" class="col-md-4 todate">
            {{ viewDate | date: 'EEEE dd MMMM yyyy' }}
    </div>
    <div class="col-md-5">
      <select (change)="viewChange.emit($event.target.value)" class="custom-select">
        <option [selected]="calendarView.value === view" *ngFor="let calendarView of views" [value]="calendarView.value">{{ calendarView.text }}</option>
      </select>
    </div>
  `,
  styles: [`
    .calendar-import-export{
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
    }

    .todate {
        color: #8F8F8F;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
    }

    .btn {
        border-radius :0; 
        cursor: pointer;
    }
    .btn-today { 
        background-color: #ffffff;
        color: #8F8F8F;
        cursor: pointer !important;
    }
    .btn-today:hover {
        color: #555555 !important;
    }
    .btn-circle {
        width: 41px;
        height: 41px;
        background-color: #ffffff;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
        cursor: pointer;
        color: #8F8F8F;
    }

    .btn-circle:hover {
        background-color: #40DC7E;
        color: white;
    }

    .btn-view {
        color: #8F8F8F;
        background-color: #ffffff;
    }

    .btn-view.active, .btn-view:hover {
        background-color: #f2f2f2;
    }

    .btn-group {
        -webkit-box-align: center;
            -ms-flex-align: center;
                align-items: center;
    }

    @media(max-width: 500px) {
        .flex-mobile-center {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
                -ms-flex-pack: center;
                    justify-content: center;
        }
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'view': [{ type: Input },],
'viewDate': [{ type: Input },],
'locale': [{ type: Input },],
'events': [{ type: Input },],
'viewChange': [{ type: Output },],
'viewDateChange': [{ type: Output },],
};
}

function CalendarHeaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
CalendarHeaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CalendarHeaderComponent.ctorParameters;
/** @type {?} */
CalendarHeaderComponent.propDecorators;
/** @type {?} */
CalendarHeaderComponent.prototype.view;
/** @type {?} */
CalendarHeaderComponent.prototype.viewDate;
/** @type {?} */
CalendarHeaderComponent.prototype.locale;
/** @type {?} */
CalendarHeaderComponent.prototype.events;
/** @type {?} */
CalendarHeaderComponent.prototype.viewChange;
/** @type {?} */
CalendarHeaderComponent.prototype.viewDateChange;
/** @type {?} */
CalendarHeaderComponent.prototype.views;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
